const ARC_LS_ROOT_ID = 'arc_language_selector'

let __actions = {
  /**
   *
   * @param {Object} selected
   * @returns String
   */
  getLabelName: (selected) => {
    return selected.replaceName || selected.name
  },
}

window.__detectAlternates = () => {
  let textHtml = `
    <div class="arc-ls-detect-alternates">
      <div>Detecting languages and countries..</div>
    </div>
  `
  const el = new DOMParser().parseFromString(textHtml, 'text/html').body.firstChild
  document.body.appendChild(el)

  let alternates = Array.from(document.querySelectorAll('link[rel]'))
    .filter((el) => el.rel === 'alternate')
    .map((item) => ({
      hreflang: item.hreflang,
      href: item.href,
      language: item.hreflang === 'x-default' ? window.Shopify.locale : item.hreflang.split('-')[0],
      country: item.hreflang === 'x-default' ? window.Shopify.country : item.hreflang.split('-')[1],
    }))
    .map((item) => ({
      ...item,
      language: item.language || window.Shopify.locale,
      country: item.country || window.Shopify.country,
    }))

  let data = { shop: window.Shopify.shop, alternates }

  let host =
    window.Shopify.shop === 'haloha-shop.myshopify.com' ? 'arena-dev-app.ap.ngrok.io' : 'language.arenacommerce.com'

  setTimeout(() => {
    fetch(`https://${host}/storefront/language-selector-detect-alternates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      response.json()

      let el = document.querySelector('.arc-ls-detect-alternates > div')
      el.innerHTML = 'Languages and countries detected successfully!'

      setTimeout(() => {
        alert('Languages and countries detected successfully!\nGo to Native Translate app and reload new data.')

        window.close()
      }, 200)
    })
  }, 2000)
}

window.__renderLanguageSelectorMain = (setting, mode, root, screen) => {
  try {
    if (!setting.alternates || !setting.languages || !setting.countries) {
      throw { message: 'Setting alternates, languages, countries is required' }
    }

    root.innerHTML = ''

    window.__handleSelectorChange = (type, value) => {
      let flagEl = document.querySelector(`.arc-ls-selector-${type} .arc-ls-selector-item-flag img`)
      let nameEl = document.querySelector(`.arc-ls-selector-${type} .arc-ls-selector-item-name`)

      switch (type) {
        case 'countries':
          setting.countrySelected = setting.countries.find((item) => item.code === value)
          flagEl.src = setting.countrySelected.flag
          nameEl.innerHTML = __actions.getLabelName(setting.countrySelected)
          break

        default:
          // languages
          setting.languageSelected = setting.languages.find((item) => item.code === value)
          flagEl.src = setting.languageSelected.flag
          nameEl.innerHTML = __actions.getLabelName(setting.languageSelected)
          break
      }

      setting.alternateSelected = setting.alternates.find(
        (item) => item.language === setting.languageSelected.code && item.country === setting.countrySelected.code,
      )
      if (!setting.alternateSelected) {
        setting.alternateSelected = setting.alternates.find(
          (item) => item.language === setting.languageSelected.code && item.country === window.Shopify.country,
        )
      }
      if (!setting.alternateSelected) {
        setting.alternateSelected = setting.alternates.find((item) => item.language === setting.languageSelected.code)
      }
    }

    window.__handleStickyClick = () => {
      let el = document.querySelector('.arc-ls-popup')
      if (el) {
        el.classList.add('arc-ls-popup__open')
      }
    }

    window.__handleCancel = () => {
      let el = document.querySelector('.arc-ls-popup')
      if (el) {
        el.classList.remove('arc-ls-popup__open')
      }
    }

    window.__handleSubmit = () => {
      let el = document.querySelector('.arc-ls-popup')
      if (el) {
        el.classList.remove('arc-ls-popup__open')
      }

      let url = window.location.href
      url = url[url.length - 1] === '/' ? url.slice(0, url.length - 1) : url

      let originHref = setting.currentAlternate.href
      originHref = originHref[originHref.length - 1] === '/' ? originHref.slice(0, originHref.length - 1) : originHref

      let newHref = setting.alternateSelected.href
      newHref = newHref[newHref.length - 1] === '/' ? newHref.slice(0, newHref.length - 1) : newHref

      url = url.replace(originHref, newHref)

      if (mode === 'PREVIEW') {
        alert(`Your site will redirect to "${url}" on online store`)
      } else {
        window.location.replace(url)
      }
    }

    window.__getAlternate = () => {
      try {
        let selected = null

        if (window.Shopify) {
          selected = setting.alternates.find(
            (item) => item.country === window.Shopify.country && item.language === window.Shopify.locale,
          )
        }

        if (!selected) {
          selected = setting.alternates.find((item) => item.hreflang === 'x-default')
        }

        return selected
      } catch (error) {
        throw error
      }
    }

    setting.alternateSelected = window.__getAlternate(setting.alternates)
    setting.languageSelected = setting.languages.find((item) => item.code === setting.alternateSelected.language)
    setting.countrySelected = setting.countries.find((item) => item.code === setting.alternateSelected.country)

    setting.currentLanguage = setting.languageSelected
    setting.currentCountry = setting.countrySelected
    setting.currentAlternate = setting.alternateSelected

    function renderRoot() {
      root.style.zIndex = setting.general.advanced.zIndex

      if (setting.screen[screen].type === 'detect_theme_position') {
        root.className = 'noselect arc_language_selector__detect_theme_position'

        root.style.top = 'auto'
        root.style.bottom = 'auto'
        root.style.left = 'auto'
        root.style.right = 'auto'

        root.style.marginLeft = setting.screen[screen].margin.left + 'px'
        root.style.marginRight = setting.screen[screen].margin.right + 'px'
        root.style.marginTop = setting.screen[screen].margin.top + 'px'
        root.style.marginBottom = setting.screen[screen].margin.bottom + 'px'
      }

      if (setting.screen[screen].type === 'fixed_position') {
        root.className = 'noselect arc_language_selector__fixed_position'

        root.style.marginLeft = 'unset'
        root.style.marginRight = 'unset'
        root.style.marginTop = 'unset'
        root.style.marginBottom = 'unset'

        switch (setting.screen[screen].fixed_position.position) {
          case 'top_left':
            root.style.top = setting.screen[screen].margin.top + 'px'
            root.style.right = 'auto'
            root.style.bottom = 'auto'
            root.style.left = setting.screen[screen].margin.left + 'px'
            break

          case 'top_right':
            root.style.top = setting.screen[screen].margin.top + 'px'
            root.style.right = setting.screen[screen].margin.right + 'px'
            root.style.bottom = 'auto'
            root.style.left = 'auto'
            break

          case 'bottom_left':
            root.style.top = 'auto'
            root.style.right = 'auto'
            root.style.bottom = setting.screen[screen].margin.bottom + 'px'
            root.style.left = setting.screen[screen].margin.left + 'px'
            break

          default:
            // bottom_right
            root.style.top = 'auto'
            root.style.right = setting.screen[screen].margin.right + 'px'
            root.style.bottom = setting.screen[screen].margin.bottom + 'px'
            root.style.left = 'auto'
            break
        }
      }
    }

    function renderStickyItem(type) {
      let selected = type === 'country' ? setting.countrySelected : setting.languageSelected

      let textHtml = `<div class="arc-ls-${type}">`

      switch (setting.screen[screen].sticky.label[type]) {
        case 'code':
          textHtml += `<span>${selected.code}</span>`
          break

        case 'name':
          textHtml += `<span>${__actions.getLabelName(selected)}</span>`
          break

        case 'flag':
          textHtml += `<img alt="${__actions.getLabelName(selected)}" src="${selected.flag}" />`
          break

        case 'flag_name':
          textHtml += `<img alt="${__actions.getLabelName(selected)}" src="${selected.flag}" />`
          textHtml += `<span>${__actions.getLabelName(selected)}</span>`
          break

        case 'name_code':
          textHtml += `<span>${__actions.getLabelName(selected)} (${selected.code})</span>`
          break

        default:
          // flag_code
          textHtml += `<img alt="${__actions.getLabelName(selected)}" src="${selected.flag}" />`
          textHtml += `<span>${selected.code}</span>`
          break
      }

      textHtml += `</div>`

      return textHtml
    }

    function renderSticky() {
      let textHtml = `<div class="arc-ls-sticky" onclick="window.__handleStickyClick()">`

      let languageHtml = renderStickyItem('language')
      let countryHtml = renderStickyItem('country')

      switch (setting.screen[screen].sticky.label.type) {
        case 'language_country':
          textHtml += languageHtml
          textHtml += `<span>-</span>`
          textHtml += countryHtml
          break

        case 'country':
          textHtml += countryHtml
          break

        default:
          // language
          textHtml += languageHtml
          break
      }

      textHtml += `</div>`

      const el = new DOMParser().parseFromString(textHtml, 'text/html').body.firstChild
      root.appendChild(el)
    }

    function renderPopup() {
      let textHtml = `
        <div class="arc-ls-popup">
          <div>
            <div class="arc-ls-close-icon" onclick="window.__handleCancel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path d="M4.34 2.93l12.73 12.73-1.41 1.41L2.93 4.35z"/>
                <path d="M17.07 4.34L4.34 17.07l-1.41-1.41L15.66 2.93z"/>
              </svg>
            </div>
            <div class="arc-ls-title">${setting.general.label.title}</div>
          </div>
        </div>
      `
      const el = new DOMParser().parseFromString(textHtml, 'text/html').body.firstChild
      if (setting.languageSelected.code === 'ar') {
        el.classList.add(`arc-ls-popup__${setting.languageSelected.code}`)
      }
      root.appendChild(el)
    }

    function renderSelector(type) {
      let selected = type === 'countries' ? setting.countrySelected : setting.languageSelected

      let optionHtmls = ''
      setting[type]
        .filter((item) => item.code !== selected.code)
        .forEach(
          (item) =>
            (optionHtmls += `
            <div class="arc-ls-selector-item" onclick="window.__handleSelectorChange('${type}','${item.code}')">
              <div class="arc-ls-selector-item-flag">
                <img src="${item.flag}" alt="" />
              </div>
              <div class="arc-ls-selector-item-name">${__actions.getLabelName(item)}</div>
            </div>
          `),
        )

      let textHtml = `
        <div class="arc-ls-selector arc-ls-selector-${type}">
          <div class="arc-ls-selector-label">Select a ${type === 'countries' ? 'country' : 'language'}</div>
          <div class="arc-ls-selector-head">
            <div class="arc-ls-selector-item">
              <div class="arc-ls-selector-item-flag">
                <img src="${selected.flag}" alt="" />
              </div>
              <div class="arc-ls-selector-item-name">${__actions.getLabelName(selected)}</div>
              <div class="arc-ls-selector-item-icon">
                <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 20l10 10 10-10z"/><path d="M0 0h48v48h-48z" fill="none"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="arc-ls-selector-body">
            <div>${optionHtmls}</div>
          </div>
        </div>
      `
      const el = new DOMParser().parseFromString(textHtml, 'text/html').body.firstChild

      let popupEl = document.querySelector('#arc_language_selector .arc-ls-popup > div')
      popupEl.appendChild(el)

      el.addEventListener('click', () => {
        el.className.includes('__open')
          ? el.classList.remove('arc-ls-selector__open')
          : el.classList.add('arc-ls-selector__open')
      })
    }

    function renderAction() {
      let textHtml = `
        <div class="arc-ls-action">
          <div class="arc-ls-action-cancel" onclick="window.__handleCancel()">${setting.general.label.cancel}</div>
          <div class="arc-ls-action-submit" onclick="window.__handleSubmit()">${setting.general.label.submit}</div>
        </div>
      `
      const el = new DOMParser().parseFromString(textHtml, 'text/html').body.firstChild

      let popupEl = document.querySelector('#arc_language_selector .arc-ls-popup > div')
      popupEl.appendChild(el)
    }

    function renderStyle() {
      // sticky
      let stickyEl = document.querySelector('.arc-ls-sticky')
      if (stickyEl) {
        stickyEl.style.backgroundColor = setting.screen[screen].sticky.backgroundColor
        stickyEl.style.color = setting.screen[screen].sticky.color
        stickyEl.style.fontFamily = setting.screen[screen].sticky.fontFamily
        stickyEl.style.fontSize = setting.screen[screen].sticky.fontSize + 'px'
        stickyEl.style.fontWeight = setting.screen[screen].sticky.fontWeight
        stickyEl.style.textTransform = setting.screen[screen].sticky.textTransform
        stickyEl.style.borderRadius = setting.screen[screen].sticky.borderRadius + 'px'
        if (setting.screen[screen].sticky.borderWidth > 0) {
          stickyEl.style.border = `${setting.screen[screen].sticky.borderWidth}px ${setting.screen[screen].sticky.borderStyle} ${setting.screen[screen].sticky.borderColor}`
        } else {
          stickyEl.style.border = 'none'
        }
      }

      // popup
      let popupEl = document.querySelector('.arc-ls-popup > div')
      if (popupEl) {
        popupEl.style.backgroundColor = setting.general.popup.backgroundColor
        popupEl.style.color = setting.general.popup.color
        popupEl.style.fontFamily = setting.general.popup.fontFamily
        popupEl.style.fontSize = setting.general.popup.fontSize + 'px'
        popupEl.style.fontWeight = setting.general.popup.fontWeight
        popupEl.style.textTransform = setting.general.popup.textTransform
        popupEl.style.borderRadius = setting.general.popup.borderRadius + 'px'
        if (setting.general.popup.borderWidth > 0) {
          popupEl.style.border = `${setting.general.popup.borderWidth}px ${setting.general.popup.borderStyle} ${setting.general.popup.borderColor}`
        } else {
          popupEl.style.border = 'none'
        }

        // close icon
        let closeIconEl = document.querySelector('.arc-ls-close-icon svg')
        if (closeIconEl) {
          closeIconEl.style.fill = setting.general.popup.color
        }
      }

      // cancel button
      let cancelButton = document.querySelector('.arc-ls-action-cancel')
      if (cancelButton) {
        cancelButton.style.backgroundColor = setting.general.button.cancel.backgroundColor
        cancelButton.style.color = setting.general.button.cancel.color
      }

      // submit button
      let submitButton = document.querySelector('.arc-ls-action-submit')
      if (submitButton) {
        submitButton.style.backgroundColor = setting.general.button.submit.backgroundColor
        submitButton.style.color = setting.general.button.submit.color
      }
    }

    renderRoot()
    renderSticky()
    renderPopup()

    switch (setting.type) {
      case 'country':
        renderSelector('countries')
        break
      case 'language':
        renderSelector('languages')
        break

      default:
        renderSelector('countries')
        renderSelector('languages')
        break
    }

    renderAction()
    renderStyle()

    window.addEventListener('click', (e) => {
      let countrySelectorEl = document.querySelector('.arc-ls-selector-countries')
      if (countrySelectorEl && !countrySelectorEl.contains(e.target)) {
        countrySelectorEl.classList.remove('arc-ls-selector__open')
      }

      let languageSelectorEl = document.querySelector('.arc-ls-selector-languages')
      if (languageSelectorEl && !languageSelectorEl.contains(e.target)) {
        languageSelectorEl.classList.remove('arc-ls-selector__open')
      }
    })

    window.addEventListener('resize', () => {
      if (window.__resizeTimeout) {
        clearTimeout(window.__resizeTimeout)
      }

      window.__resizeTimeout = setTimeout(() => {
        window.__renderLanguageSelector(setting, mode)
      }, 200)
    })
  } catch (error) {
    console.log(error)
    throw error
  }
}

window.__renderLanguageSelectorDetectThemePosition = (setting, screen) => {
  try {
    document.querySelectorAll(`#${ARC_LS_ROOT_ID}`).forEach((_el) => _el.remove())

    function filterElement(element) {
      if (element.parentNode) {
        if (element.parentNode.tagName === 'DIV') {
          return element
        } else if (element.parentNode.tagName === 'LI') {
          return element.parentNode
        } else {
          return filterElement(element.parentNode)
        }
      }
      return null
    }

    function generateQuerySelector(element) {
      if (element.tagName === 'HTML') return element.tagName
      if (element.id) return `#${element.id}`

      let selector = ''
      if (element.tagName) {
        selector = element.tagName
      }

      return generateQuerySelector(element.parentNode) + ' > ' + selector
    }

    function getPosition(event) {
      let positionX = event.clientX
      let positionY = event.clientY

      if (document.documentElement.scrollTop > 0) {
        positionY = positionY + document.documentElement.scrollTop
      }

      return { x: positionX, y: positionY }
    }

    function createActionBlock(position) {
      Array.from(document.querySelectorAll('.__action_block')).forEach((_el) => _el.remove())

      let actionBlock = document.createElement('DIV')
      actionBlock.className = '__action_block'
      actionBlock.style.left = position.x + 'px'
      actionBlock.style.top = position.y - 30 + 'px'

      let btnBefore = document.createElement('BUTTON')
      btnBefore.className = '__action_btn'
      btnBefore.innerHTML = 'Before'
      btnBefore.addEventListener('click', (e) => {
        e.preventDefault()
        Array.from(document.querySelectorAll('.__action_btn_selected')).forEach((_el) =>
          _el.classList.remove('__action_btn_selected'),
        )
        btnBefore.className = '__action_btn __action_btn_selected'
        handlePositionClick(position, 'before')
      })

      let btnAfter = document.createElement('BUTTON')
      btnAfter.className = '__action_btn'
      btnAfter.innerHTML = 'After'
      btnAfter.addEventListener('click', (e) => {
        e.preventDefault()
        Array.from(document.querySelectorAll('.__action_btn_selected')).forEach((_el) =>
          _el.classList.remove('__action_btn_selected'),
        )
        btnAfter.className = '__action_btn __action_btn_selected'
        handlePositionClick(position, 'after')
      })

      actionBlock.appendChild(btnBefore)
      actionBlock.appendChild(btnAfter)

      document.getElementsByTagName('BODY')[0].appendChild(actionBlock)
    }

    function handlePositionClick(element, position) {
      Array.from(document.querySelectorAll('.__submit_block')).forEach((_element) => _element.remove())

      setting.screen[screen].theme_selector.position = position

      let submitBlock = document.createElement('DIV')
      submitBlock.className = '__submit_block'

      let submitLabel = document.createElement('DIV')
      submitLabel.className = '__submit_label'
      submitLabel.innerText = 'Unsaved changes'

      let btnDiscard = document.createElement('BUTTON')
      btnDiscard.className = '__submit_btn __discard'
      btnDiscard.innerHTML = 'Discard'
      btnDiscard.addEventListener('click', (e) => {
        e.preventDefault()
        handleDiscard()
      })

      let btnSubmit = document.createElement('BUTTON')
      btnSubmit.className = '__submit_btn __submit'
      btnSubmit.innerHTML = 'Submit'
      btnSubmit.addEventListener('click', (e) => {
        e.preventDefault()
        btnSubmit.className = '__disabled'
        handleSubmit()
      })

      submitBlock.appendChild(submitLabel)
      submitBlock.appendChild(btnDiscard)
      submitBlock.appendChild(btnSubmit)

      document.querySelector('.__action_block').remove()

      document.getElementsByTagName('BODY')[0].appendChild(submitBlock)

      handlePreview(position)
    }

    function handleSubmit() {
      let _setting = JSON.parse(JSON.stringify(setting))
      delete _setting.alternateSelected
      delete _setting.countrySelected
      delete _setting.languageSelected

      let host =
        window.Shopify.shop === 'haloha-shop.myshopify.com' ? 'arena-dev-app.ap.ngrok.io' : 'language.arenacommerce.com'

      fetch(`https://${host}/storefront/language-selector-detect-theme-position`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shop: window.Shopify.shop,
          setting: _setting,
        }),
      }).then((response) => {
        response.json()

        alert('New setting saved. \nGo to the Native Translate app and reload new setting.')

        window.close()
      })
    }

    function handleDiscard() {
      document.querySelectorAll(`#${ARC_LS_ROOT_ID}`).forEach((_el) => _el.remove())

      Array.from(document.querySelectorAll('.__action_btn_selected')).forEach((_el) =>
        _el.classList.remove('__action_btn_selected'),
      )
      Array.from(document.querySelectorAll('.__action_block')).forEach((_el) => _el.remove())
      Array.from(document.querySelectorAll('.__submit_block')).forEach((_el) => _el.remove())
    }

    function handlePreview(position) {
      document.querySelectorAll(`#${ARC_LS_ROOT_ID}`).forEach((_el) => _el.remove())

      let element = document.querySelector(setting.screen[screen].theme_selector.selector)

      let root = document.createElement('DIV')
      root.id = ARC_LS_ROOT_ID

      switch (position) {
        case 'before':
          element.insertAdjacentElement('beforebegin', root)
          break

        case 'after':
          element.insertAdjacentElement('afterend', root)
          break

        default:
          break
      }

      window.__renderLanguageSelectorMain(setting, 'LIVE', root, screen)
    }

    function handleMouseMove(event) {
      if (document.querySelector('.__submit_block')) {
        // Nothing
      } else {
        let element = filterElement(event.target)

        if (element) {
          let index =
            Array.from(element.parentNode.childNodes)
              .filter((_el) => _el.tagName === element.tagName)
              .indexOf(element) + 1

          let selector = generateQuerySelector(element.parentNode) + ` > ${element.tagName}:nth-child(${index})`

          element = document.querySelector(selector)

          if (element) {
            if (element.className.includes('__action_block') || element.className.includes('__action_btn')) {
              // Nothing
            } else {
              if (selector != setting.screen[screen].theme_selector.selector) {
                Array.from(document.querySelectorAll('.__selected_element')).forEach((_el) =>
                  _el.classList.remove('__selected_element'),
                )

                element.classList.add('__selected_element')

                setting.screen[screen].theme_selector.selector = selector
              }

              if (window.__mousemoveTimeout) {
                clearTimeout(window.__mousemoveTimeout)
              }

              window.__mousemoveTimeout = setTimeout(() => {
                let position = getPosition(event)
                createActionBlock(position)
              }, 200)
            }
          }
        }
      }
    }

    document.addEventListener('mousemove', function (event) {
      if (!event?.target?.className?.includes?.('__action_btn')) {
        handleMouseMove(event)
      }
    })
  } catch (error) {
    console.log(error)
    throw error
  }
}

window.__renderLanguageSelector = (_setting = null, _mode = 'LIVE', _screen = null) => {
  let setting = _setting
  let mode = _mode
  let screen = _screen
  let root = null

  try {
    if (!setting) {
      throw { message: 'Invalid setting' }
    }

    if (!screen) {
      screen = document.body.clientWidth > setting.general.advanced.mobileScreenWidth ? 'desktop' : 'mobile'
    }

    if (window.location.search.includes('mode=detect-theme-position')) {
      screen = window.location.search.includes('screen=mobile') ? 'mobile' : 'desktop'

      setting = {
        ...setting,
        screen: {
          ...setting.screen,
          [screen]: {
            ...setting.screen[screen],
            type: 'detect_theme_position',
            sticky: {
              ...setting.screen[screen].sticky,
              label: {
                ...setting.screen[screen].sticky.label,
                language: 'code',
              },
              borderWidth: 0,
              textTransform: 'uppercase',
              backgroundColor: 'transparent',
            },
            margin: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
        },
      }

      window.__renderLanguageSelectorDetectThemePosition(setting, screen)
      return
    } else if (window.location.search.includes('mode=detect-alternates')) {
      window.__detectAlternates()
      return
    } else {
      if (mode === 'LIVE') {
        if (setting.screen[screen].type === 'detect_theme_position') {
          document.querySelectorAll(`#${ARC_LS_ROOT_ID}`).forEach((_el) => _el.remove())

          let selector = setting.screen[screen].theme_selector.selector
          let position = setting.screen[screen].theme_selector.position

          if (!selector) {
            throw { message: 'Selector cannot be blank' }
          }

          let element = document.querySelector(selector)
          if (!element) {
            throw { message: 'Selector element not found' }
          }

          root = document.createElement('DIV')
          root.id = ARC_LS_ROOT_ID

          switch (position) {
            case 'before':
              element.insertAdjacentElement('beforebegin', root)
              break

            case 'after':
              element.insertAdjacentElement('afterend', root)
              break

            default:
              break
          }
        } else {
          document.querySelectorAll(`#${ARC_LS_ROOT_ID}`).forEach((el) => el.remove())

          root = document.createElement('DIV')
          root.id = ARC_LS_ROOT_ID
          document.body.appendChild(root)
        }
      } else {
        root = document.getElementById(ARC_LS_ROOT_ID)
      }
    }

    if (!root) {
      throw { message: 'Root element not found' }
    } else {
      window.__renderLanguageSelectorMain(setting, mode, root, screen)
    }
  } catch (error) {
    console.log('+++++++++++++++++++++++++++++++')
    console.log('Render Language Selector failed:', error.message)
    console.log('+++++++++++++++++++++++++++++++')
  }
}

window.addEventListener('load', () => {
  window.NativeTranslate = window.NativeTranslate || {}
  window.NativeTranslate.languageSelector = window.NativeTranslate.languageSelector || null

  let setting = window.NativeTranslate.languageSelector

  if (setting) {
    window.__renderLanguageSelector(setting)
  }
})
